<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template lang="html">
    <div id="data-list-list-view" class="data-list-container" @click="closeSelects">
        <vs-table
            ref="table"
            no-data-text="Nenhum documento encontrado"
            multiple
            v-model="selected"
            :max-items="itemsPerPage"
            :data="documents"
        >
            <div slot="header" class="flex w-full items-end">
                <div>
                    <vs-input
                        placeholder="Buscar"
                        class="w-full input-rounded-full no-icon-border mr-4"
                        icon="icon-search"
                        icon-pack="feather"
                        v-model="term"
                        @keyup.enter="searchHandler(true)"
                    />
                </div>

                <div class="flex flex-wrap-reverse items-center flex-grow justify-end">
                    <div class="flex flex-wrap-reverse items-start">
                        <vs-select
                            class="mr-4"
                            label="Nível de Acesso"
                            v-model="selectedAccessLevel"
                        >
                            <vs-select-item
                                :key="index"
                                :value="item.value"
                                :text="item.text"
                                v-for="(item, index) in accessLevels"
                            />
                        </vs-select>

                        <vs-select
                            class="mr-4"
                            placeholder="Selecione os usuários"
                            multiple
                            label="Usuários"
                            v-model="selectedUsers"
                            :disabled="!showSelectUsers"
                            ref="usersSelect"
                        >
                            <vs-select-item
                                :key="index"
                                :value="item.value"
                                :text="item.text"
                                v-for="(item, index) in usersOptions"
                            />
                        </vs-select>

                        <vs-button color="success" type="filled" @click="openConfirm()">Atualizar</vs-button>
                    </div>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="id">ID</vs-th>
                <vs-th sort-key="title_default">Título</vs-th>
                <vs-th sort-key="access_level">Nível de Acesso</vs-th>
                <vs-th>&nbsp;</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <p class="term font-medium">{{ tr.id }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.title_default }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.access_level | access_level }}</p>
                        </vs-td>
                        <vs-td>
                            <router-link :to="`/documents/${tr.id}`">
                                <vx-tooltip text="Abrir documento" class="w-6 h-6" color="grey">
                                    <feather-icon icon="EyeIcon" class="w-6 h-6"></feather-icon>
                                </vx-tooltip>
                            </router-link>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <vs-pagination
            :total="pageCount"
            v-model="currentPage"
            class="mt-base"
            @input="searchHandler()"
        ></vs-pagination>
    </div>
</template>

<script>
import { sync, call } from "vuex-pathify";
export default {
    data() {
        return {
            accessLevels: [
                { text: "Administrador", value: "administrator" },
                { text: "Todos os irmãos", value: "restrict" },
                {
                    text: "Irmãos (apenas selecionados)",
                    value: "specific_restrict"
                },
                { text: "Público", value: "public" }
            ],
            itemsPerPage: 40,
            isMounted: false
        };
    },
    computed: {
        currentPage: sync("manageDocuments/currentPage"),
        documents: sync("manageDocuments/documents"),
        pageCount: sync("manageDocuments/pageCount"),
        selected: sync("manageDocuments/selectedItems"),
        selectedAccessLevel: sync("manageDocuments/accessLevel"),
        selectedUsers: sync("manageDocuments/selectedUsers"),
        term: sync("manageDocuments/term"),
        selectedIds() {
            const ids = this.selected.map(selected => selected.id);

            return ids;
        },
        showSelectUsers() {
            return this.selectedAccessLevel === "specific_restrict";
        },
        users: sync("manageDocuments/users"),
        usersOptions() {
            const options = this.users.map(user => ({
                text: user.name,
                value: user.id
            }));

            return options;
        }
    },
    async created() {
        // Reset page state
        this.reset();
    },
    async mounted() {
        this.isMounted = true;
        this.fetchUsers();
    },
    methods: {
        ...call([
            "manageDocuments/fetch",
            "manageDocuments/fetchUsers",
            "manageDocuments/update",
            "manageDocuments/reset"
        ]),
        async searchHandler(resetPagination = false) {
            if (resetPagination) {
                this.currentPage = 1;
            }
            
            this.$vs.loading();
            try {
                await this.fetch();
                this.$vs.loading.close();
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Não foi possível carregar esta página. Tente novamente mais tarde, por favor.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        },
        closeSelects() {
            this.$refs.usersSelect.closeOptions();
        },
        openConfirm() {
            this.$vs.dialog({
                type: "confirm",
                color: "success",
                title: "Tem certeza que deseja atualizar?",
                text:
                    "Tem certeza que deseja atualizar a permissão dos documentos selecionados?",
                acceptText: "Atualizar",
                cancelText: "Cancelar",
                accept: this.updateHandler
            });
        },
        async updateHandler() {
            this.$vs.loading();
            await this.update();
            this.$vs.loading.close();
        }
    }
};
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {
        .vs-table--header {
            display: flex;
            flex-wrap: wrap-reverse;
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            > span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    & + i {
                        left: 1rem;
                    }

                    &:focus + i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                td {
                    padding: 20px;
                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }
                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }
                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }
            th.td-check {
                padding: 0 15px !important;
            }
            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }
    }
}
</style>
